import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export const useAllClocksTagsQuery = () => {
  return useQuery({
    queryKey: ["allClocksTags"],
    queryFn: () => adminApiClient.getAllClocksTags(),
    refetchOnWindowFocus: false,
  });
};
